import { findConfigurationStyle } from '../boxes/styleTemplate';
import { siteValuesFromClassic } from '../theme/styleSchema';
import { TABLE_STYLE_SCHEMA } from './tableStyleSchema';

/**
 * Style du configurateur d'un tableau du document.
 *
 * Format possible de l'identifiant : "2_section_...", "2", etc. — un style
 * venu d'une section liée porte un suffixe (cf. utils/styles.js).
 */
export function findProposalTableStyle(tableStyleId, configuration) {
  if (tableStyleId == null || !configuration) return null;
  return findConfigurationStyle(configuration.tableStyles, tableStyleId)
    || configuration[String(tableStyleId).split('_')[0]]
    || null;
}

/**
 * `design` du bloc Tableau du site pour un tableau du document de style
 * `tableStyleId`. Sans style trouvable, les défauts du document (sa police).
 * La correspondance réglage par réglage vit dans TABLE_STYLE_SCHEMA.
 */
export function proposalTableDesign(tableStyleId, configuration) {
  return siteValuesFromClassic(
    TABLE_STYLE_SCHEMA,
    findProposalTableStyle(tableStyleId, configuration),
    { fontFamily: configuration?.fontFamily, fontSize: configuration?.fontSize },
  );
}
